'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { AgbContent } from './content';

export default function AgbPageClient() {
  return (
    <Fragment>
      <Container>
        <AgbContent />
      </Container>
    </Fragment>
  );
}
